import { useDispatch } from 'react-redux';
import { showTooltip } from '../../components/tooltips/tooltipActions';
import { useRef } from 'react';
import randomString from '../../../common/uid/randomString';
import { TooltipPositions } from '../../components/tooltips/tooltipConstants';
import classNames from 'classnames';
import platformSingleton from '../../platform/platformSingleton';

const useBoardNavigationTooltip = ({ elementId }: { elementId: string }) => {
    const dispatch = useDispatch();
    const stableTooltipId = useRef(`tip-${randomString(6)}`);

    const dispatchShowNavigationTooltip = () => {
        const message = platformSingleton.features.isTouch ? `Double-tap to open` : `Double-click to open`;

        dispatch(
            showTooltip({
                id: stableTooltipId.current,
                tooltip: {
                    selector: `#el-${elementId} .BoardIcon`,
                    text: message,
                    position: TooltipPositions.TOP,
                    duration: 2000,
                    fade: true,
                    className: classNames('Tooltip', 'small'),
                    delay: 500,
                    pollPosition: true,
                    hideOnEvent: 'pointerdown',
                },
            }),
        );
    };

    return {
        dispatchShowNavigationTooltip,
    };
};

export default useBoardNavigationTooltip;
